const CardJSX = (link: any, destination: any) => {
    return {
        data: {
            ressource: '',
            dontStatus: true,
            img: '',
            status: 'visible',
            statusActive: '',
            statusDeactive: '',
            link: 'translation.de.slug',
            prelink: link + '/magazin/[param]/',
            prelinksearch: 'translation.de.slug',
            title: 'type',
            descriptionShow: true,
            description: 'subject',
            AddressDontShowGF: true,
            AddressShow: true,
            Address: [
                {
                    street: 'address.street',
                    plz: 'address.postcode',
                    city: 'address.city',
                    HRB: 'hrb',
                    gffirstname: 'address.first_name',
                    gflastname: 'address.last_name'
                }
            ],
            router: 'id',
            preroute: '/' + destination + '/Detail/',
            edit: '',
            delete: false,
            Dontvisited: true,
            deleteLink: ''
        }
    }
}

export default CardJSX
